import { LavenderMark } from './BrandIcons';

/**
 * The brand lockup and one optional trailing action.
 *
 * The wordmark is deliberately NOT translated — "plant.habb.me" is the product's
 * name in every market. It is set in two weights of the display serif, per
 * design system §2.1: an editorial `plant.` against a lighter `habb.me`, which is
 * what carries the botanical-magazine character a single weight of the UI sans
 * never did.
 *
 * There is no tagline here. §2.2 keeps the tagline for brand moments — the
 * landing hero already says it at three times this size, and printing it on
 * every screen's header is exactly the "attach it to every UI instance of the
 * logo" the brand system warns against.
 *
 * `mark` follows the same reasoning one step further. It arrived because the
 * landing drew the lavender large in its hero, and a second, smaller copy of the
 * same illustration a few centimetres above it was the mark competing with
 * itself. The hero's copy has since been removed, so on the landing the answer
 * is now simply "no mark" rather than "not twice". Either way the route table
 * decides, and this component only has to honour the answer.
 */
export default function BrandHeader({ action = null, mark = true, onOpenSettings = null, settingsLabel = null }) {
    const lockup = (
        <>
            {mark ? <LavenderMark className="brand-header__mark" /> : null}
            {/* A `<span>` rather than a `<p>`: a paragraph is not phrasing
                content and cannot legally live inside the button below. It is a
                flex item either way, so nothing about the composition moves. */}
            <span className="brand-header__wordmark">
                plant.
                <span className="brand-header__wordmark-tail">
                    habb<span className="brand-header__wordmark-suffix">.me</span>
                </span>
            </span>
        </>
    );

    return (
        <header className="brand-header">
            {/* The lockup opens the settings drawer (SPEC-018 D-4). The
                accessible name is the ACTION, not the wordmark: a control is
                announced for what it does, and the product's name is already on
                the document title. */}
            {onOpenSettings ? (
                <button
                    type="button"
                    className="brand-header__lockup"
                    onClick={onOpenSettings}
                    aria-label={settingsLabel}
                    aria-haspopup="dialog"
                >
                    {lockup}
                </button>
            ) : lockup}
            {action}
        </header>
    );
}
